import React from 'react'
import { Panel, Row, Col } from 'rsuite'

import UpdateListAttachFilesTable from './UpdateListAttachFilesTable'
import AccountingPeriodWidget from '../panelHeder/AccountingPeriodWidget'
import { getDateThaiShort } from '../../utils/dataUtil'

export default function UpdateListFormView({
  schema,
  periodInfo,
  onPreview = () => {},
  onDownload = () => {},
  ...props
}) {
  return (
    <>
      <Panel
        bordered
        style={{
          marginTop: 25,
          border: '1px solid #4e4b488c',
        }}
        header={<AccountingPeriodWidget periodInfo={periodInfo} />}
      >
        <Row style={{ marginTop: 5 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', fontWeight: 550 }}>
            {schema.documentNumber.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.documentNumber.value}
          </Col>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', fontWeight: 550 }}>
            {schema.documentDate.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {/* {schema.documentDate.value}
             */}
            {schema.documentDate.value ? getDateThaiShort(schema.documentDate.value) : ''}
          </Col>
        </Row>
        <Row style={{ marginTop: 5 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', fontWeight: 550 }}>
            {schema.description.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {schema.description.value}
          </Col>
        </Row>
        <Row style={{ marginTop: 25 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right', fontWeight: 550 }}>
            {schema.attachFiles.label || 'เอกสารแนบประกอบ'}
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            <UpdateListAttachFilesTable
              //schema={schema?.attachFiles}
              data={schema?.attachFiles?.values}
              onDownload={onDownload}
              onPreview={onPreview}
            />
          </Col>
        </Row>
      </Panel>
    </>
  )
}
